<template>
  <div class="section--addnew">
    <div class="row">
      <div class="col-lg-3">
        <div class="idea-info">
          <IdeaChecklist :key="key" :idea="idea" typeChecklist="create"/>
        </div>
      </div>

      <div class="col-lg-9">
        <div class="idea-content">
          <div class="form-section">
            <div :class="['form-block', {'form-block--similar': similarTitle, 'form-block--warning': validation.headline}]">
              <div class="form-block-inner">
                <label>Title</label>
                <input id="add-new-title" v-model="idea.headline" type="text" placeholder="Add a title of your idea">
              </div>
<!--              <div class="form-error-similar" v-if="similarTitle"><span>This title sounds familiar. <br><button class="link" @click="openPopup($event, 'similar')"><span>Click here</span></button> to check ideas that are similar.</span></div>-->
              <div class="form-error" v-if="validation.headline">
                <i class="icon-error"></i> Title is required
              </div>
            </div>
            <div class="form-block" :class="{'form-block--warning': validation.contentPost}">
              <div class="form-block-inner">
                <label>Description</label>
                <textarea v-model="idea.contentPost" placeholder="Add description of your idea"></textarea>
              </div>
              <div class="form-error" v-if="validation.contentPost">
                <i class="icon-error"></i> Description is required
              </div>
            </div>

            <div class="form-block form-block--cover-image" :class="{'form-block--warning': validation.idFile}">
              <label>Main Photo</label>
              <div class="form-block-flexer">
                <ImageWrapper :file="idea.idFile" alt="cover-photo" v-if="idea.idFile" :key="idea.idFile"></ImageWrapper>
                <div v-else class="image-placeholder">
                  <img src="../../assets/images/pic.svg">
                </div>
                <button class="button-icon d-none d-lg-flex" @click="openPopup($event, 'pic')">Choose main picture <i class="icon-img"></i></button>
                <button class="button-icon d-lg-none" @click="menuPic = true">Choose main picture <i class="icon-img"></i></button>
              </div>
              <div class="form-error" v-if="validation.idFile">
                <i class="icon-error"></i> Main Photo is required
              </div>
            </div>
          </div>

          <div class="form-section">
            <div class="row form-block" :class="{'form-block--warning': validation.idCategory}">
              <div class="col-lg-7" :class="{'form-block--locked': disableCategory}">
                <div class="form-block-inner form-block-inner--selector">
                  <label>Category</label>
                  <Selector
                      :id="'category'"
                      :filterKey="'category'"
                      :selectorOptions="categoriesOptions"
                      @change="setCategory"
                      :options="{mobileView: true, mobileViewLabel: 'Category'}"
                  />
                </div>
                <div class="form-error" v-if="validation.idCategory">
                  <i class="icon-error"></i> Category is required
                </div>
              </div>
            </div>

            <FieldSwitch v-for="field of contentFields" :field="field" @changed="changeFields" :validationError="getValidationForField(field)" :key="field.idContentField"/>


            <div class="form-bottom">
              <a class="link d-none d-lg-flex" @click="$router.go(-1)"><span>Cancel</span></a>
              <button id="add-new-send" class="button-icon button--submit" :class="{inactive: disableButton}" @click="openPopup($event,'publish1')">Publish <i class="icon-send"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>

<!--    similar pop-->
    <transition name="fade">
      <SimilarIdeasPopup v-if="popupSimilar" @closePopup="closePopup('similar')"></SimilarIdeasPopup>
    </transition>

<!--    cover popup-->
    <transition name="fade">
      <MobileCoverPopup v-if="menuPic" :cover="cover" @selectCover="selectCover" @selectPhoto="selectPhoto"></MobileCoverPopup>
    </transition>
    <!--    cover popup-->
    <transition name="fade">
      <CoverImagePopup v-if="popupPic" @closePopup="closePopup('pic')" @selectCover="selectCover" @selectPhoto="selectPhoto"></CoverImagePopup>
    </transition>
<!-- popupPublish -->
    <transition name="fade">
      <div class="popup-wrapper" v-if="popupPublish1">
        <div class="popup-overlay" @click="closePopup('publish1')"></div>
        <div class="popup popup--idea-publish">
          <button class="popup-close" @click="closePopup('publish1')"></button>
          <span class="popup-title">You are about to publish your idea, are you sure it's ready?</span>
          <p>Once you publish your idea it will be visible to all instance users and you will not be able to edit it. Please consider checking the content again.</p>
          <div class="form-bottom">
            <button class="link" @click="closePopup('publish1')"><span>Back to edit</span></button>
<!--            <span class="span-icon"><span>Saved as draft (Dec 8, 2020; 11:43)</span></span>-->
            <button class="button-icon button--submit" @click="save()">Publish my idea <i class="icon-send"></i></button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="popup-wrapper" v-if="popupPublish2">
        <div class="popup-overlay" @click="closePopup('publish2')"></div>
        <div class="popup popup--idea-publish">
          <button class="popup-close" @click="closePopup('publish2')"></button>
          <span class="popup-title">It seems that similar ideas have already been posted.<br>Have a look at them:</span>
          <div class="popup-box">
            <a class="link-icon"><span>Boxes for New Joiners</span> <i class="icon-arrow"></i></a>
            <div class="box-user">
              <div class="box-user-img">
                <img src="../../assets/images/pic-person.jpg">
              </div>
              <span>John Griffin + 3 more people</span>
            </div>
          </div>
          <div class="popup-box">
            <a class="link-icon"><span>Welcome packs for everyone</span> <i class="icon-arrow"></i></a>
            <div class="box-user">
              <div class="box-user-img">
                <img src="../../assets/images/pic-person.jpg">
              </div>
              <span>Jurrien Oldhof</span>
            </div>
          </div>
        </div>

        <div class="form-bottom">
          <button class="link" @click="closePopup('publish2')"><span>Back to edit</span></button>
          <span class="span-icon"><span>Saved as draft (Dec 8, 2020; 11:43)</span></span>
          <button class="button-icon button--submit" @click="save()">Add my idea anyway <i class="icon-send"></i></button>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="popup-wrapper" v-if="popupError">
        <div class="popup-overlay" @click="closePopup('popupError')"></div>
        <div class="popup popup--idea-publish">
          <button class="popup-close" @click="closePopup('popupError')"></button>
          <span class="popup-title">Something went wrong at our end. Sorry about that.</span>
          <span>Please contact your administrator.</span>
          <label>Error Details:</label>
          <textarea disabled v-model="error"></textarea>
          <button class="button-icon button--submit" @click="copyToClipboard(error)">Copy to clipboard</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import settings from "@/settings";
import IdeaChecklist from "@/components/ideas/IdeaChecklist";
import Selector from "@/components/forms/Selector";
import files from '@/api/files'
import ideas from '@/api/ideas'
import FieldSwitch from "@/components/forms/FieldSwitch";
import ImageWrapper from "@/components/general/ImageWrapper";
import SimilarIdeasPopup from "@/components/ideas/Modals/SimilarIdeasPopup";
import MobileCoverPopup from "@/components/ideas/Modals/MobileCoverPopup";
import CoverImagePopup from "@/components/ideas/Modals/CoverImagePopup";
export default {
name: "IdeaForm",
  components: {
    CoverImagePopup, MobileCoverPopup, SimilarIdeasPopup, ImageWrapper, FieldSwitch, Selector, IdeaChecklist},
  data() {
  return {
    similarTitle: false,
    popupSimilar: false,
    popupPic: false,
    popupPublish1: false,
    popupPublish2: false,
    menuPic: false,
    popupError: false,
    error: {},
    coversIndex: 1,
    uploadStatus: 'before', //before, during, after
    idea: {
      headline: '',
      contentPost: '',
      idFile: '',
      idType: '',
      idSettingCompany: '',
      idCategory: '',
      contentFields:[],
      status: null,
    },
    key: 0,
    locations: [],
    fields: [],
    offers: [],
    photoModal: false,
    uploadedPhoto: {},
    selectedPhoto: {},
    disableCategory: false,
    disableOffer: false,
    disableButton: false,
    challenge: {},
    uploadingImage: false,
    publishIdea: false,
    //hardcoded for now
    cover: '',
    validation: {}
  }
},
computed: {
  contentFields() {
    return this.$store.getters.contentFieldsForIdeaBoard
  },
  categories() {
    return this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.IDEA_BOARD_CATEGORIES).filter((item) => {
      return item.value.toLowerCase().includes(this.searchCategories.toLowerCase()) || !this.searchCategories
    })
  },
  categoriesOptions() {
    let categories = []
    this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.IDEA_BOARD_CATEGORIES).forEach(item => {
      categories.push({
        id: item.idSettingCompany,
        name: item.value,
        value: item.idSettingCompany,
        active: item.idSettingCompany === this.idea.idCategory,
      })
    })
    return categories;
  }
},
mounted() {
  this.$store.dispatch('getImagesCategories', {id_company: this.$store.getters.selectedCompanyId});
},
methods: {
  copyToClipboard(text) {
    const textarea = document.createElement('textarea');
    document.body.appendChild(textarea);
    textarea.value = text;
    textarea.select();
    textarea.setSelectionRange(0, 99999);
    document.execCommand('copy');
    document.body.removeChild(textarea);
  },
  getValidationForField(field) {
    if(!this.validation.contentFields) {
      return false
    }
    return this.validation.contentFields[field.idContentField]
  },
  save() {
    let data = this.prepareData('PUBLISH');
    this.validation = {};
    this.validateData(data);
    if(!Object.keys(this.validation).length) {
      ideas.addIdea(data, (res) => {
        this.$router.push({name: 'IdeaOverview', params: {id: res.idPost}} )
      }, (error) => {
        this.error = JSON.stringify(error)
        this.closePopup('publish1')
        this.openPopup(null, 'popupError')
        return;
      })
    }
    this.$nextTick(() => {
      let errorDiv = document.getElementsByClassName("form-block--warning");
      if(errorDiv) {
        errorDiv[0].scrollIntoView({behavior: 'smooth'})
      }
    })
    this.closePopup('publish1')
  },
  prepareData(status) {
    let data = {
      contentFields: this.idea.contentFields,
      idSettingCompany: this.$store.getters.sectionByCode(settings.MODULES.IDEA_BOARD).idSettingCompany,
      contentPost: this.idea.contentPost,
      headline: this.idea.headline,
      idCategory: this.idea.idCategory,
      idFile: this.idea.idFile,
      idUser: this.$store.getters.user.idUser,
      status: status
    }
    return data
  },
  validateData(data) {
    Object.keys(data).forEach((key) => {
      if(Array.isArray(data[key])) {
        this.contentFields.forEach(item => {
          if(item.isRequired) {
            let answer = data[key].find(elem => {
              return elem.idContentField === item.idContentField
            })
            if(!answer || (answer.type === 'OPEN' && !answer.value)) {
              if(!this.validation[key]) {
                this.validation[key] = {}
              }
              this.validation[key][item.idContentField] = true
            }
          }
        })
        return;
      }
      if(!data[key]) {
        this.validation[key] = true;
      }
    })
  },
  changeFields(val) {
    let index = this.idea.contentFields.findIndex((item) => {
      return item.idContentField === val.idContentField
    })
    if(index !== -1) {
      this.idea.contentFields[index] = val
      return true;
    }
    this.idea.contentFields.push(val)
  },
  setCategory(cat) {
    this.idea.idCategory = cat[0].value
  },
  userFriendlyCategory(id) {
    let category = this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.IDEA_BOARD_CATEGORIES).find(item => {
      return item.idSettingCompany === id
    })
    return category.value
  },
  selectCover() {
    if(this.cover.idFile) {
      this.idea.idFile = this.cover.idFile
    } else {
      //todo change address
      fetch(`${settings.APP_DOMAIN}/${this.cover}`).then((r) => {
        r.blob().then(blob => {
          const file = new File([blob], 'image.jpg', {type: blob.type});
          files.addFile(file, (data) => {
            this.idea.idFile = data.idFile
          })
        });
      })
    }
    this.closePopup('pic');
    this.closePopup('menuPic');
  },
  uploadPhoto () {
    this.uploadingImage = true
    let file = this.$refs.photo.files[0]
    files.addFile(file, (data) => {
      this.uploadedPhoto = data
      this.uploadingImage = false
    })
  },
  selectPhoto (val) {
    this.cover = val
  },
  cancelUpload () {
    this.uploadStatus = 'before'
  },
  openPopup (e, popup) {
    if(e) {
      e.preventDefault()
    }
    if (popup === 'similar') {
      this.popupSimilar = 1
    } else if (popup === 'pic') {
      this.popupPic = 1
    } else if (popup === 'publish1') {
      this.popupPublish1 = 1
    } else if (popup === 'publish2') {
      this.popupPublish2 = 1
    }else if (popup === 'popupError') {
      this.popupError = 1
    }
    document.querySelector('body').classList.add('nooverflow')
  },
  closePopup (popup) {

    if (popup == 'similar') {
      this.popupSimilar = 0
    } else if (popup == 'pic') {
      this.popupPic = 0
    } else if (popup == 'menuPic') {
      this.menuPic = 0
    } else if (popup == 'publish1') {
      this.popupPublish1 = 0
    } else if (popup == 'publish2') {
      this.popupPublish2 = 0
    } else if (popup == 'popupError') {
      this.popupError = 0
    }
    document.querySelector('body').classList.remove('nooverflow')
  },
}
}
</script>

<style scoped>

</style>
